import $ from "jquery"

let translate = {
  en:{

  },
  ar:{
    "OF_SHOW" : "من برنامج"
  }
}

class Search {
  // 1. describe and create/initiate our object
  constructor() {
    this.addSearchHTML()
    this.resultsDiv = $("#search-overlay__results")
    this.openButton = $(".js-search-trigger")
    this.closeButton = $(".search-overlay__close")
    this.searchOverlay = $(".search-overlay")
    this.searchField = $("#search-term")
    this.events()
    this.isOverlayOpen = false
    this.isSpinnerVisible = false
    this.previousValue
    this.typingTimer
  }

  // 2. events
  events() {
    this.openButton.on("click", this.openOverlay.bind(this))
    this.closeButton.on("click", this.closeOverlay.bind(this))
    $(document).on("keydown", this.keyPressDispatcher.bind(this))
    this.searchField.on("keyup", this.typingLogic.bind(this))
  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer)

      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html('<div class="spinner-loader"></div>')
          this.isSpinnerVisible = true
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750)
      } else {
        this.resultsDiv.html("")
        this.isSpinnerVisible = false
      }
    }

    this.previousValue = this.searchField.val()
  }

  getResults() {

      $.getJSON(samaData.root_url + "/wp-json/radiosamr/v1/search?term=" + this.searchField.val(),
      (results) => {
        //var combinedResults = posts[0].concat(pages[0])
        this.resultsDiv.html(`
<div class="container my-5">
<div class="row">


<div class="col-12 col-xl-3 col-lg-4">
<!-- shows reaults -->
<h3>البرامج</h3>
${results.shows.length ? '<ul class="link-list min-list">' : "<p>لا يوجد برنامج متعلق ببحثك</p>"}
${results.shows.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}
${results.shows.length ? "</ul>" : ""}




</div>

<div class="col-12 col-xl-3 col-lg-4">
<!-- shows reaults -->
<h3>فريق راديو سمر</h3>
${results.team.length ? '<ul class="link-list min-list">' : "<p>لا يوجد شخص متعلق ببحثك</p>"}
${results.team.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}
${results.team.length ? "</ul>" : ""}

</div>

<div class="col-12 col-xl-3 col-lg-4">
<!-- shows reaults -->
<h3>الحلقات</h3>
${results.episodes.length ? '<ul class="link-list min-list">' : "<p>لا يوجد حلقة متعلقة ببحثك</p>"}
${results.episodes.map(item => `<li><a href="${item.permalink}">${item.title}</a> ${item.relatedShow ?  ` <span class="in_search_text"> ${translate.ar.OF_SHOW} </span>  <a href="${item.showLink}">${item.relatedShow}</a> ` : ""}</li>`).join("")}
${results.episodes.length ? "</ul>" : ""}

</div>

<div class="col-12 col-xl-3 col-lg-4">
<h3>معلومات عامة</h3>
${results.generalInfo.length ? '<ul class="link-list min-list">' : "<p>لا يوجد نتائج</p>"}
<!-- // ${results.generalInfo.map(item => `<li><a href="//${item.permalink}">${item.title}</a> //${item.postType == "post" ? `by //${item.authorName}` : ""}</li>`).join("")} -->
${results.generalInfo.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}

${results.generalInfo.length ? "</ul>" : ""}

</div>

</div>
</div>

      `)
        this.isSpinnerVisible = false
      },
      () => {
        this.resultsDiv.html("<p>Unexpected error; please try again.</p>")
      }
    )
  }

  keyPressDispatcher(e) {
    if (e.keyCode == 83 && !this.isOverlayOpen && !$("input, textarea").is(":focus")) {
      this.openOverlay()
    }

    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeOverlay()
    }
  }

  openOverlay() {
    this.searchOverlay.addClass("search-overlay--active")
    $("body").addClass("body-no-scroll")
    this.searchField.val("")
    setTimeout(() => this.searchField.focus(), 301)
    console.log("our open method just ran!")
    this.isOverlayOpen = true
  }

  closeOverlay() {
    this.searchOverlay.removeClass("search-overlay--active")
    $("body").removeClass("body-no-scroll")
    console.log("our close method just ran!")
    this.isOverlayOpen = false
  }

  addSearchHTML() {
    $("body").append(`
      <div class="search-overlay">
        <div class="search-overlay__top">
          <div class="container">
            <i class="fa fa-search search-overlay__icon" aria-hidden="true"></i>
            <input type="text" class="search-term" placeholder="ما الذي تبحث عنه؟" id="search-term">
            <i class="fa fa-window-close search-overlay__close" aria-hidden="true"></i>
          </div>
        </div>
        
        <div class="container">
          <div id="search-overlay__results"></div>
        </div>

      </div>
    `)
  }
}

export default Search
